


























import { defineComponent } from '@nuxtjs/composition-api';
import { ARCHIVES_SIDE_MENU, ARCHIVES_WINE_TYPE_MENU, ARCHIVES_LOCALES_MENU } from '~/constants';

export default defineComponent({
  setup(props, { emit }) {
    /**
     * カテゴリ検索
     * @param query カテゴリのid
     * @param area 産地
     */
    const emitCategory = (query?: string, type?: string) => {
      emit('category', query, type);
    };
    return { ARCHIVES_SIDE_MENU, ARCHIVES_WINE_TYPE_MENU, ARCHIVES_LOCALES_MENU, emitCategory };
  },
});
